import VerticalBarChart from './VerticalBarChart'

export default VerticalBarChart
